<template>
    <div v-if="pessoa" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Pessoa Jurídica</h4>
        <router-link to="/cadastros/pessoas-juridicas">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <FormSection title="Dados da Empresa">
        <p><strong>Razão Social:</strong> {{ pessoa.razao_social }}</p>
        <p><strong>Nome Fantasia:</strong> {{ pessoa.nome_fantasia }}</p>
        <p><strong>CNPJ:</strong> {{ formatarCNPJ(pessoa.cnpj) }}</p>
        <p><strong>Telefone:</strong> {{ pessoa.telefone1 || 'Não informado' }}</p>
        <p><strong>Celular:</strong> {{ pessoa.telefone2 || 'Não informado' }}</p>
        <p><strong>Email:</strong> {{ pessoa.email || 'Não informado' }}</p>
      </FormSection>
  
      <FormSection title="Endereço">
        <p><strong>CEP:</strong> {{ pessoa.cep || 'Não informado' }}</p>
        <p><strong>Endereço:</strong> {{ pessoa.endereco || 'Não informado' }}</p>
        <p><strong>Número:</strong> {{ pessoa.numero || 'Não informado' }}</p>
        <p><strong>Bairro:</strong> {{ pessoa.bairro || 'Não informado' }}</p>
        <p><strong>Complemento:</strong> {{ pessoa.complemento || 'Não informado' }}</p>
        <p><strong>Estado:</strong> {{ pessoa.estado_nome || 'Não informado' }}</p>
        <p><strong>Município:</strong> {{ pessoa.municipio_nome || 'Não informado' }}</p>
      </FormSection>
  
      <FormSection title="Observações">
        <p>{{ pessoa.observacoes || 'Não informado' }}</p>
      </FormSection>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
    import axios from "@/services/axios";
    import FormSection from "@/components/Layout/FormSection.vue";

    export default {
    components: { FormSection },
    data() {
        return {
        pessoa: null,
        estados: [], // Lista de estados
        municipios: [], // Lista de municípios
        };
    },
    methods: {
        async carregarDetalhes() {
        try {
            const response = await axios.get(
            `/cadastros/pessoas-juridicas/${this.$route.params.id}`
            );
            this.pessoa = response.data;

            // Após carregar os detalhes, carregue os nomes do estado e município
            await this.carregarEstadoNome();
            await this.carregarMunicipioNome();
        } catch (error) {
            console.error("Erro ao carregar os detalhes da pessoa jurídica:", error);
        }
        },

        async carregarEstadoNome() {
        try {
            const response = await axios.get(`/localidades/estados`);
            this.estados = response.data;

            // Procura o estado pelo código e atribui o nome
            const estado = this.estados.find((e) => e.id === this.pessoa.estado_cod);
            this.pessoa.estado_nome = estado ? estado.nome : "Não informado";
        } catch (error) {
            console.error("Erro ao carregar estados:", error);
        }
        },

        async carregarMunicipioNome() {
        try {
            if (!this.pessoa.estado_cod) {
            this.pessoa.municipio_nome = "Não informado";
            return;
            }

            const response = await axios.get(
            `/localidades/municipios/${this.pessoa.estado_cod}`
            );
            this.municipios = response.data;

            // Procura o município pelo código e atribui o nome
            const municipio = this.municipios.find(
            (m) => m.id === this.pessoa.municipio_cod
            );
            this.pessoa.municipio_nome = municipio ? municipio.nome : "Não informado";
        } catch (error) {
            console.error("Erro ao carregar municípios:", error);
        }
        },
          // Método para formatar o CNPJ
        formatarCNPJ(cnpj) {
            if (!cnpj) return 'Não informado';
            return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        },

    },
    mounted() {
        this.carregarDetalhes();
    },
    };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  </style>
  